import styled from 'styled-components'

export const StyledRoot = styled.div`
    position: absolute;
    inset: 0;
`
